import { HubConnectionBuilder } from '@microsoft/signalr'
import store from '@/store/index'

class NotificationHubConnection {
  connection
  isConnecting
  connectionPromise

  constructor () {
    this.connection = null
    this.connectionPromise = null
    this.isConnecting = false
  }

  connect () {
    if (this.isConnecting) {
      return this.connectionPromise
    }

    this.isConnecting = true

    const retryPolicy = {
      nextRetryDelayInMilliseconds: () => 15 * 1000
    }

    this.connection = new HubConnectionBuilder()
      .withUrl(store.getters['localSettings/clientAppUrl'] + '/' + 'barcode-hub')
      .withAutomaticReconnect(retryPolicy)
      .build()

    this.connectionPromise = this.connection.start()

    return this.connectionPromise
  }

  on (methodName, newMethod) {
    if (this.connection !== null) {
      this.connection.on(methodName, newMethod)
    }
  }

  off (methodName) {
    if (this.connection !== null) {
      this.connection.off(methodName)
    }
  }

  invoke (methodName, ...args) {
    if (this.connection === null || this.connectionPromise === null) {
      return Promise.resolve()
    }

    return this.connectionPromise.then(() => {
      this.connection.invoke(methodName, ...args)
    })
  }

  disconnect () {
    if (this.connection !== null) {
      this.connection.stop()
    }

    this.connection = null
    this.connectionPromise = null
    this.isConnecting = false
  }
}

export default new NotificationHubConnection()



// WEBPACK FOOTER //
// ./src/hub/NotificationHubConnection.js